import { httpUtil } from './httpUtil'
import { ErrorCodes, createResult, createCommonResult } from './resultUtil'
import { getData } from '../../utils/common';
export const config = {
  getIndustries,
  getIndustrySectors,
  getAppCfg,
  getOrganisationTags,
  getOrganisation,
  getQueues,
  getListServiceRequests,
  createServiceRequest,
  getListFilesServiceRequest,
  getDetailFile,
  uploadAttachmentSR,
  uploadFiles,
  uploadFilesNew
}

async function getAppCfg(applicationID, cloundName) {
  try {
    var app_id = await getData("APP_ID");
    if (!app_id) {
      app_id = applicationID;
    }
    var queryParams = {}
    if (app_id){
      queryParams.platform_app_id = app_id;
    }
    else{
      queryParams.cloud_name = cloundName;
    }
    //console.log('API: ', contact)
    let response = await httpUtil.get({
      resourcePath: '/v1/applications',
      queryParams: queryParams,
      logOutIfSessionInvalid: false
    });
    //check return code here instead of put as there would be different intepretation for different API
    return createCommonResult(response);
  } catch (e) {
    console.log('Exception getIndustries: ', e);
    return createResult(ErrorCodes.UNKNOWN, e);
  }
}

async function getOrganisationTags({
  page = 1,
  size = 1000,
  sort,//='UPDATED_DATE',
  order, //='DESC'
  industry,
  industry_sector
} = {},) {
  try {

    //console.log('API: ', contact)
    let response = await httpUtil.get({
      resourcePath: '/v1/organisation_tags',
      queryParams: {
        page,
        size,
        sort,//='UPDATED_DATE',
        order, //='DESC'
        industry,
        industry_sector
      }
    });
    //check return code here instead of put as there would be different intepretation for different API
    return createCommonResult(response);
  } catch (e) {
    console.log('Exception getOrganisationTags: ', e);
    return createResult(ErrorCodes.UNKNOWN, e);
  }
}

async function getIndustries({
  page = 1,
  size = 1000,
  sort,//='UPDATED_DATE',
  order, //='DESC'
} = {},) {
  try {

    //console.log('API: ', contact)
    let response = await httpUtil.get({
      resourcePath: '/v1/industries',
      queryParams: {
        page,
        size,
        sort,//='UPDATED_DATE',
        order, //='DESC'
      }
    });
    //check return code here instead of put as there would be different intepretation for different API
    return createCommonResult(response);
  } catch (e) {
    console.log('Exception getIndustries: ', e);
    return createResult(ErrorCodes.UNKNOWN, e);
  }
}

async function getIndustrySectors({
  industry_name,
  page = 1,
  size = 1000,
  sort,//='UPDATED_DATE',
  order, //='DESC'
} = {},) {
  try {

    //console.log('API: ', contact)
    let response = await httpUtil.get({
      resourcePath: '/v1/industry_sectors',
      queryParams: {
        industry_name,
        page,
        size,
        sort,//='UPDATED_DATE',
        order, //='DESC'
      }
    });
    //check return code here instead of put as there would be different intepretation for different API
    return createCommonResult(response);
  } catch (e) {
    console.log('Exception getIndustries: ', e);
    return createResult(ErrorCodes.UNKNOWN, e);
  }
}

async function getAppConfig() {
  var result = {
    disable_order: false,
    authenticate_by: "email",
  }
  return {
    code: "OK",
    data: result
  }
}

async function getOrganisation() {
  try {

    let current_organisation_id = httpUtil.getSession().current_organisation_id;
    let response = await httpUtil.get({
      resourcePath: '/v1/organisations/' + current_organisation_id,
    });
    //check return code here instead of put as there would be different intepretation for different API
    return createCommonResult(response);
  } catch (e) {
    console.log('Exception getIndustries: ', e);
    return createResult(ErrorCodes.UNKNOWN, e);
  }
}

async function getQueues({
  state_for_self_service = 'ENABLED',
  state = 'DISABLED',
} = {},) {
  try {
    let response = await httpUtil.get({
      resourcePath: '/v1/queues',
      queryParams: {
        state_for_self_service,
        state,
      }
    });
    //check return code here instead of put as there would be different intepretation for different API
    return createCommonResult(response);
  } catch (e) {
    console.log('Exception getIndustries: ', e);
    return createResult(ErrorCodes.UNKNOWN, e);
  }
}

async function getListServiceRequests({
  state = null,
} = {},) {
  try {
    let id = httpUtil.getSession().sub;
    let response = await httpUtil.get({
      resourcePath: '/v1/contacts/' + id + '/service_requests/',
      queryParams: {
        state,
      }
    });
    //check return code here instead of put as there would be different intepretation for different API
    return createCommonResult(response);
  } catch (e) {
    console.log('Exception getIndustries: ', e);
    return createResult(ErrorCodes.UNKNOWN, e);
  }
}

async function createServiceRequest({
  description,
  queue_id,
}) {
  try {
    let id = httpUtil.getSession().sub;
    let response = await httpUtil.post({
      resourcePath: '/v1/contacts/' + id + '/service_requests/',
      body: {
        description,
        queue_id,
      },
      withAccessToken: true
    });
    return createCommonResult(response);
  } catch (e) {
    console.log('Exception addDevice: ', e);
    return createResult(ErrorCodes.UNKNOWN, e);
  }
}

async function getListFilesServiceRequest(service_id) {
  try {
    let response = await httpUtil.get({
      resourcePath: '/v1/service_requests/' + service_id + '/files/',
      withAccessToken: true,
    });
    //check return code here instead of put as there would be different intepretation for different API
    return createCommonResult(response);
  } catch (e) {
    console.log('Exception getListFilesServiceRequest: ', e);
    return createResult(ErrorCodes.UNKNOWN, e);
  }
}

async function getDetailFile(file_id) {
  try {
    let response = await httpUtil.get({
      resourcePath: '/v1/files/' + file_id,
      withAccessToken: true,
      returnBlob:true
    });
    //check return code here instead of put as there would be different intepretation for different API
    return createCommonResult(response);
  } catch (e) {
    console.log('Exception getDetailFile: ', e);
    return createResult(ErrorCodes.UNKNOWN, e);
  }
}
async function uploadAttachmentSR({
  service_id,
  file_id
}={}) {
  try {
    let response = await httpUtil.post({
      resourcePath: "/v1/service_requests/" + service_id + "/files",
      body: {
        file_id
      },
      withAccessToken: true,
    });
    //check return code here instead of put as there would be different intepretation for different API
    if (response.code == "OK")
      return createResult(ErrorCodes.OK, response.data);
    else {
      createResult(ErrorCodes.UNKNOWN, response.error);
    }
  } catch (e) {
    console.log("Exception uploadAttachmentSR: ", e);
    return createResult(ErrorCodes.UNKNOWN, e);
  }
}

async function uploadFiles({
  file
}={}) {
  try {
    let response = await httpUtil.uploadFile({
      resourcePath: "/v1/upload/files",
      fileData: file,
      body: {},
      withAccessToken: true,
    });
    //check return code here instead of put as there would be different intepretation for different API
    if (response.code == "OK")
      return createResult(ErrorCodes.OK, response.data);
    else {
      createResult(ErrorCodes.UNKNOWN, response.error);
    }
  } catch (e) {
    console.log("Exception uploadFiles: ", e);
    return createResult(ErrorCodes.UNKNOWN, e);
  }
}

async function uploadFilesNew({
  file
}={}) {
  try {
    let response = await httpUtil.uploadFileNew({
      resourcePath: "/v1/upload/files",
      fileData: file,
      body: {},
      withAccessToken: true,
    });
    //check return code here instead of put as there would be different intepretation for different API
    if (response.code == "OK")
      return createResult(ErrorCodes.OK, response.data);
    else {
      createResult(ErrorCodes.UNKNOWN, response.error);
    }
  } catch (e) {
    console.log("Exception uploadFiles: ", e);
    return createResult(ErrorCodes.UNKNOWN, e);
  }
}